import { FC } from 'react'
import { Button } from '@wellesley/ui'
import { AppsRoutes, AppsLink } from '@wellesley/router'

export type LinkItem = { text: string; link: string; icon?: React.ReactNode }

type LinksProps = {
  linksList: LinkItem[]
}
export const Links: FC<LinksProps> = ({ linksList }) => {
  return (
    <div className="text-gray-700">
      <div className="gap-xs flex flex-col items-center">
        {linksList.map(({ text, link, icon }, index) => (
          <AppsLink key={link} to={link as AppsRoutes}>
            <Button
              className="min-w-[200px]"
              variant={index ? 'tertiary' : 'primary'}
            >
              {icon}
              {text}
            </Button>
          </AppsLink>
        ))}
      </div>
    </div>
  )
}
